import { useSearchParams } from "react-router-dom";

export const BASE_FORM_MODES = ["create", "edit", "view"] as const;

export type BaseFormMode = (typeof BASE_FORM_MODES)[number];

function useFormParams<
  TMode extends string = BaseFormMode,
  TParams extends { [K in keyof TParams]: string | null } = {},
>(
  validModes: readonly TMode[],
  extraParams?: readonly (keyof TParams & string)[],
  defaultMode?: TMode,
): { mode: TMode } & TParams {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") as TMode | null;

  if (!validModes.includes(mode as TMode)) {
    if (defaultMode !== undefined) {
    } else {
      throw new Error(`Invalid or missing form mode: "${mode}"`);
    }
  }

  const resolvedMode = (
    validModes.includes(mode as TMode) ? mode : defaultMode
  ) as TMode;

  const extra = Object.fromEntries(
    (extraParams ?? []).map((key) => [key, searchParams.get(key)]),
  ) as TParams;

  return { mode: resolvedMode, ...extra };
}

export default useFormParams;
